/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFlagCheckered = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5 2v2h17v13H5v5H3V2zm9 7h-3V6H8v3H5v3h3v3h3v-3h3v3h3v-3h3V9h-3v3h-3V9h3V6h-3zm-3 0v3H8V9z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFlagCheckered as FlagCheckered };
